export default __webpack_public_path__ + "static/media/overallEarningsIcon.813e12ae.svg";